import React from 'react'

import SlideOver from '../../../../ui/SlideOver'
import { DepartmentContainer } from '../../../DesktopMenu/components/DepartmentContainer'
import { MobileNavbarHeader } from '../MobileNavbarHeader'
import NavbarCategorieView from '../Navigation/NavbarCategorieView'

type CategorieViewProps = {
  setIndicators: React.Dispatch<React.SetStateAction<string[]>>
  indicators: string[]
  setViewNumber: React.Dispatch<React.SetStateAction<number>>
  setBreadcrumb: (title: string) => void
  setSubcategoriPosition: React.Dispatch<React.SetStateAction<number>>
}

type RenderNavbarCategorieViewProps = {
  currentItem: string
  setCurrentItem: (currentItem: string) => void
  closeModal?: () => unknown
  isLink?: boolean
  viewNumber?: number
  mainSlug?: string
  slug?: string
  subCategorieItems?: {
    title: string
    slug: string
    subcategorie: {
      title: string
      slug: string
    }[]
  }[]
}

interface MobileLateralMenuProps {
  showMenu: boolean
  dismissTransition: any
  viewNumber: number
  couponsLoading: boolean
  hasActiveCoupons: boolean
  position?: number
  currentCategorie: string
  allCategories: any
  categorieViewProps: CategorieViewProps
  currentSubCategorie: string
  subcategoriPosition: number
  handleSetCurrentItem: (currentItem: string) => void
  handleSetCurrentSubCategorie: (currentItem: string) => void
  handleSetBreadcrumb?: (title: string) => void
  handleSetViewNumber?: (position: number) => void
  handleOnDismiss: () => void
  handleSetShowMenu: (showMenu: boolean) => void
  handleSetPosition: (position: number) => void
  handleCloseMenu: () => void
}

export const MobileLateralMenu = ({
  showMenu,
  dismissTransition,
  viewNumber,
  couponsLoading,
  hasActiveCoupons,
  position,
  currentCategorie,
  allCategories,
  categorieViewProps,
  currentSubCategorie,
  subcategoriPosition,
  handleSetCurrentSubCategorie,
  handleSetShowMenu,
  handleOnDismiss,
  handleCloseMenu,
  handleSetCurrentItem,
  handleSetPosition,
  handleSetBreadcrumb,
  handleSetViewNumber,
}: MobileLateralMenuProps) => {
  const renderNavbarCategorieView = (props: RenderNavbarCategorieViewProps) => (
    <NavbarCategorieView
      currentItem={props.currentItem}
      setCurrentItem={props.setCurrentItem}
      closeModal={props.closeModal}
      isLink={props.isLink}
      viewNumber={props.viewNumber ?? 0}
      mainSlug={props.mainSlug}
      slug={props.slug}
      subCategorieItems={props.subCategorieItems ?? []}
      {...categorieViewProps}
    />
  )

  return (
    <SlideOver
      isOpen={showMenu}
      onDismiss={handleOnDismiss}
      onDismissTransition={(callback) => {
        dismissTransition.current = callback
      }}
      size="full"
      direction="leftSide"
      className="navbar__modal-content"
    >
      <div className="navbar__modal-body">
        <MobileNavbarHeader
          dismissTransition={dismissTransition}
          setShowMenu={handleSetShowMenu}
        />
        {viewNumber === 0 && (
          <DepartmentContainer
            couponsLoading={couponsLoading}
            hasActiveCoupons={hasActiveCoupons}
            position={position}
            closeMenu={handleCloseMenu}
            setPosition={handleSetPosition}
            setBreadcrumb={handleSetBreadcrumb}
            setViewNumber={handleSetViewNumber}
          />
        )}

        {viewNumber === 1 &&
          position !== undefined &&
          renderNavbarCategorieView({
            currentItem: currentCategorie,
            setCurrentItem: handleSetCurrentItem,
            closeModal: handleCloseMenu,
            isLink: false,
            viewNumber: 2,
            mainSlug: allCategories?.[position]?.slug,
            subCategorieItems: allCategories?.[position]?.categorie,
          })}

        {viewNumber == 2 &&
          position !== undefined &&
          renderNavbarCategorieView({
            currentItem: currentSubCategorie,
            setCurrentItem: handleSetCurrentSubCategorie,
            closeModal: handleCloseMenu,
            isLink: true,
            viewNumber: 3,
            mainSlug: allCategories?.[position]?.slug,
            slug: allCategories?.[position]?.categorie[subcategoriPosition]
              ?.slug,
            subCategorieItems:
              allCategories?.[position]?.categorie[subcategoriPosition]
                ?.subcategorie,
          })}
      </div>
    </SlideOver>
  )
}
